import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { appLanguage, defaultLang } from './_constants/appSetting.constant';
import { LOCALSTORAGEKEYS } from './_constants/localStorageKeys';
import { LocalService } from './_services/_storage/local.service';

@Component({
    selector: 'lokos-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    standalone: false,
})
export class AppComponent {
    title = 'clf-web2-keycloak';

    constructor(
        private translate: TranslateService,
        private localService: LocalService
    ) {
        this.initLanguage();
    }

    private initLanguage(): void {
        this.translate.setDefaultLang(defaultLang.langCode);
        let langCode = defaultLang.langCode;
        try {
            const saved = this.localService.get(LOCALSTORAGEKEYS.SELECTED_LANGUAGE);
            if (saved) {
                const lang = typeof saved === 'string' ? JSON.parse(saved) : saved;
                const isKnown = appLanguage.some((l) => l.langCode === lang?.langCode);
                if (isKnown) {
                    langCode = lang.langCode;
                }
            }
        } catch {
            langCode = defaultLang.langCode;
        }
        this.translate.use(langCode);
    }
}
